'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableStackCapturing = exports.withTasks = exports.withTask = exports.taskMiddleware = exports.taskCreator = exports.reportTasksForTesting = undefined;

var _core = require('./core');

Object.defineProperty(exports, 'reportTasksForTesting', {
  enumerable: true,
  get: function get() {
    return _core.reportTasksForTesting;
  }
});

var _legacy = require('./legacy');

Object.defineProperty(exports, 'taskCreator', {
  enumerable: true,
  get: function get() {
    return _legacy.taskCreator;
  }
});

var _redux = require('./redux');

Object.defineProperty(exports, 'taskMiddleware', {
  enumerable: true,
  get: function get() {
    return _redux.taskMiddleware;
  }
});
Object.defineProperty(exports, 'withTask', {
  enumerable: true,
  get: function get() {
    return _redux.withTask;
  }
});
Object.defineProperty(exports, 'withTasks', {
  enumerable: true,
  get: function get() {
    return _redux.withTasks;
  }
});
Object.defineProperty(exports, 'disableStackCapturing', {
  enumerable: true,
  get: function get() {
    return _redux.disableStackCapturing;
  }
});

var _testUtils = require('./test-utils');

Object.keys(_testUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _testUtils[key];
    }
  });
});


// This default export provides a nice alias:
// ```
// import Task from 'react-palm/tasks';
// Task.all([...])
// ```
exports.default = {
  all: _core.all,
  fromCallback: _core.fromCallback,
  fromPromise: _core.fromPromise
};

// In the future, test utils will not be exported from
// this main bundle


//////////////////
// WEBPACK FOOTER
// ./~/react-palm/tasks/index.js
// module id = 244
// module chunks = 0